import { combineReducers } from "@reduxjs/toolkit";
import floorPlanReducer from "./floor-plan.slice";

const facilityReducer = combineReducers({
  floorPlan: floorPlanReducer
});

export default facilityReducer;
